import type { BoxResult } from '../types';

export type BoxItemEntry = { name: string; count: number };

export const aggregateItemPositions = (positions: BoxResult['itemPositions']): BoxItemEntry[] => {
  if (!positions?.length) return [];
  const counts = new Map<string, number>();
  for (const pos of positions) {
    const name = pos.item?.name ?? '';
    if (name) counts.set(name, (counts.get(name) ?? 0) + 1);
  }
  return Array.from(counts.entries()).map(([name, count]) => ({ name, count }));
};
